import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import Logo from './Logo';
import logoHeader from '../_assets/imgs/logo-header.png';
import accountLogo from '../_assets/imgs/account.png';

const Header = ({ without }) => {
  function renderBusiness() {
    return (
      <nav className="header-nav nav nav-tabs">
        <NavLink className="nav-link" to="/vacancies">
          Vacantes
        </NavLink>
        <NavLink className="nav-link" to="/applicants">
          Solicitantes
        </NavLink>
        <NavLink className="nav-link" to="/companies">
          Compañías
        </NavLink>
      </nav>
    );
  }

  function renderProfile() {
    return (
      <Link to="/profile">
        <div className="float-right account">
          <img src={accountLogo} alt="Perfil" />
        </div>
      </Link>
    );
  }

  return (
    <div className="header">
      <Logo logo={logoHeader} />
      {!without ? renderBusiness() : ''}
      {!without ? renderProfile() : ''}
    </div>
  );
};

export default Header;
